import styled from 'styled-components';

const EventContent = styled.div`
  display: block;
  min-width: 0;
  overflow: hidden;
  color: white;
  font-size: 12px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const AccountName = styled.span`
  opacity: .9;
`

export default function ImplementationCalendarEvent({ event }) {
  const { 
    name, 
    accountName 
  } = event.resource || {};

  const title = [name, accountName].filter(Boolean).join(' - ');

  return (
    <EventContent title={title}>
      <span>{name}</span>
      {accountName &&
        <AccountName>{` - ${accountName}`}</AccountName>
      }
    </EventContent>
  );
}
